import { EntityContainerModel, bl_fi_entity_hdr_RowInterface, bl_fi_mst_entity_line_RowInterface } from 'blg-akaun-ts-lib';
import * as moment from 'moment';
import { Constants } from '../models/constants.model';

export class CustomerViewModel {
  bl_fi_mst_entity_hdr: bl_fi_entity_hdr_RowInterface;
  bl_fi_mst_entity_line: bl_fi_mst_entity_line_RowInterface[];
  // property names must match table column names for sorting to work
  guid: string;
  customer_code: string;
  name: string;
  txn_type: string;
  id_type: string;
  id_no: string;
  id_no_old: string;
  gender: string;
  dob: string;
  fiscal_year_end_month: string;
  tax_reg_number: string;
  tax_category: string;
  country_alpha3_code: string;
  ccy_code: string;
  descr: string;
  default_arap_type: string;
  phone: string;
  email: string;
  website_url: string;
  business_nature_code: string;
  classification: string;
  alternate_tax_no_1: string;
  alternate_tax_no_2: string;
  gst_number: string;
  wht_tax_number: string;
  nationality: string;
  ethnicity: string;
  language_code: string;
  title: string;
  region_code: string;
  marital_status: string;
  occupation: string;
  job_title: string;
  job_industry: string;
  job_role: string;
  ref_1: string;
  ref_2: string;
  status: string;
  created_date: string;
  updated_date: string;
  addresses_json: JSON;
}

export function containerToViewModel(customer: EntityContainerModel): CustomerViewModel {
  let hdr = customer.bl_fi_mst_entity_hdr;
  let line = customer.bl_fi_mst_entity_line;
  let dob = hdr.dob ? moment(hdr.dob).format(Constants.DATEFORMAT) : '';
  let create_date = moment(hdr.created_date).format(Constants.DATETIMEFORMAT);
  let updated_date = moment(hdr.updated_date).format(Constants.DATETIMEFORMAT);
  return {
    bl_fi_mst_entity_hdr: hdr,
    bl_fi_mst_entity_line: line,
    guid: hdr.guid,
    customer_code: hdr.customer_code,
    name: hdr.name,
    txn_type: hdr.txn_type,
    id_type: hdr.id_type,
    id_no: hdr.id_no,
    id_no_old: hdr.id_no_old,
    gender: hdr.gender,
    dob: dob,
    fiscal_year_end_month: hdr.fiscal_year_end_month ? hdr.fiscal_year_end_month.toString() : '',
    tax_reg_number: hdr.tax_reg_number,
    tax_category: hdr.tax_category,
    country_alpha3_code: hdr.country_alpha3_code,
    ccy_code: hdr.ccy_code,
    descr: hdr.descr,
    default_arap_type: hdr.default_arap_type,
    phone: hdr.phone,
    email: hdr.email,
    website_url: hdr.website_url,
    business_nature_code: hdr.business_nature_code,
    classification: hdr.classification,
    alternate_tax_no_1: hdr.alternate_tax_no_1,
    alternate_tax_no_2: hdr.alternate_tax_no_2,
    gst_number: hdr.gst_number,
    wht_tax_number: hdr.wht_tax_number,
    nationality: hdr.nationality,
    ethnicity: hdr.ethnicity,
    language_code: hdr.language_code,
    title: hdr.title,
    region_code: hdr.region_code,
    marital_status: hdr.marital_status,
    occupation: hdr.occupation,
    job_title: hdr.job_title,
    job_industry: hdr.job_industry,
    job_role: hdr.job_role,
    ref_1: hdr.ref_1,
    ref_2: hdr.ref_2,
    created_date: create_date,
    updated_date: updated_date,
    status: hdr.status,
    addresses_json: hdr.addresses_json
  } as CustomerViewModel;
}

